import { render, staticRenderFns } from "./QxFormItem.vue?vue&type=template&id=8e6e9d2a&scoped=true&"
import script from "./QxFormItem.vue?vue&type=script&lang=js&"
export * from "./QxFormItem.vue?vue&type=script&lang=js&"
import style0 from "./QxFormItem.vue?vue&type=style&index=0&id=8e6e9d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6e9d2a",
  null
  
)

export default component.exports